import { memo, useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectConfigPopupIntro } from '@containers/Home/selectors';
import { useTourEventState } from '@containers/Home/global/TourStats';
import { useKrpano } from '@containers/Home/hook/useKrpano';
import { useMobileDetect } from '@containers/Home/hook/useDetectMobile';
import { PopupIntroWrapper } from './styled';

const PopupIntro = memo(() => {
  const isMakeChange = useRef(false);
  const videoRef = useRef<HTMLVideoElement>(null!);
  const configPopupIntro = useSelector(selectConfigPopupIntro);
  const { isShowIconInfoPlace, onShowInfoPlace, onCloseDialogPostProject } =
    useKrpano({});
  const { checkDevice } = useMobileDetect();
  const [tourEventStats, setTourEventState] = useTourEventState('state');

  const onClosePopupIntro = useCallback(() => {
    if (configPopupIntro?.type === 'post') onCloseDialogPostProject();
    setTourEventState(prev => ({
      ...prev,
      isVisiblePopupIntro: false,
    }));
  }, [configPopupIntro, onCloseDialogPostProject, setTourEventState]);

  useEffect(() => {
    if (tourEventStats.isVisiblePopupIntro === undefined) {
      const isVisiblePopupIntro =
        ((configPopupIntro?.type === 'image' &&
          configPopupIntro?.imageDesktop) ||
          (configPopupIntro?.type === 'video' &&
            configPopupIntro?.videoDesktop) ||
          (configPopupIntro?.type === 'post' && isShowIconInfoPlace)) &&
        !!configPopupIntro?.isEnabled;
      if (isVisiblePopupIntro) {
        if (configPopupIntro?.type === 'post') {
          onShowInfoPlace();
          isMakeChange.current = true;
        }
        if (configPopupIntro?.type === 'video' && videoRef.current) {
          // videoRef.current.volume = 1;
          videoRef?.current?.play();
        }
      }
      setTourEventState(prev => ({ ...prev, isVisiblePopupIntro }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      tourEventStats.isVisiblePopupIntro &&
      configPopupIntro?.isAutoClose &&
      configPopupIntro?.type !== 'post'
    )
      setTimeout(() => {
        onClosePopupIntro();
      }, +configPopupIntro?.timeAutoClose * 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourEventStats.isVisiblePopupIntro, configPopupIntro]);

  useEffect(() => {
    if (
      configPopupIntro?.type === 'post' &&
      isMakeChange.current &&
      !tourEventStats.visibleDialogPostProject &&
      tourEventStats.isVisiblePopupIntro !== undefined
    )
      onClosePopupIntro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourEventStats.visibleDialogPostProject]);

  return (
    <PopupIntroWrapper
      className={tourEventStats.isVisiblePopupIntro !== false ? '' : 'inactive'}
    >
      {configPopupIntro && configPopupIntro?.isEnabled && (
        <>
          {configPopupIntro?.type === 'image' && (
            <>
              <img
                src={configPopupIntro?.imageDesktop}
                alt=""
                className="--pc"
              />
              <img
                src={
                  configPopupIntro?.imageMobile ||
                  configPopupIntro?.imageDesktop
                }
                alt=""
                className="--mobile"
              />
            </>
          )}

          {configPopupIntro?.type === 'video' && (
            <>
              {!checkDevice().isMobile() ? (
                <video
                  muted
                  autoPlay
                  playsInline
                  ref={videoRef}
                  onEnded={onClosePopupIntro}
                >
                  <source
                    src={configPopupIntro?.videoDesktop}
                    type="video/mp4"
                  />
                </video>
              ) : (
                <video
                  muted
                  autoPlay
                  playsInline
                  ref={videoRef}
                  onEnded={onClosePopupIntro}
                  className="--mobile"
                >
                  <source
                    src={
                      configPopupIntro?.videoMobile ||
                      configPopupIntro?.videoDesktop
                    }
                    type="video/mp4"
                  />
                </video>
              )}
            </>
          )}

          {configPopupIntro?.type !== 'post' && (
            <div className="overlayClose">
              <div onClick={onClosePopupIntro} className="close">
                {configPopupIntro?.textClose || 'Close'}
              </div>
            </div>
          )}
        </>
      )}
    </PopupIntroWrapper>
  );
});

export default PopupIntro;
